module.exports = __webpack_public_path__ + "img/data_analytics.6c3d638b.svg";